
import { Component, VModel, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import { deserialise } from 'kitsu-core'

@Component({
    mixins: [ObservationMixin],
    inheritAttrs: false,
})
export default class ProjectFilter extends Mixins<MixinInterface>(ObservationMixin) {
    @VModel() filter!: string | null
    @Prop({ default: 'observation.view_own' }) permission!: string

    get availableProjects() {
        const desProjects = deserialise({
            data: this.lodash.cloneDeep(this.allProjects),
        }).data.filter((project) => project?.permissions?.includes(this.permission))
        return desProjects
    }
}
